export default __webpack_public_path__ + "static/media/Icon awesome-image.22c12089.svg";